import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Justificativa } from '../models/justificativa.model';
import { Page } from '../models/page.model';

@Injectable({
    providedIn: 'root'
})
export class JustificavaService extends BaseService<Justificativa> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/justificativa`, injector);
    }

    getByEstimativaId(estimativaId: number): Observable<Page<Justificativa>> {
        return this.http.get<Page<Justificativa>>(`${environment.API_PRICE}/justificativa/getByEstimativaId/${estimativaId}`);
    }
}
